import InfoCircle from '@/assets/icons/warning-circle/warning-circle.svg'
import { UsernameProcessType, UrlProcessType } from './text-node-with-process-type';

type MessageType = {
  text: string;
  icon: string;
}

export const MESSAGE_SAVE_USERNAME: Record<UsernameProcessType, MessageType> = {
  POST_VISIBLE: {
    text: 'Haz tu publicación visible para todos.',
    icon: InfoCircle
  },
  SEARCH_POST: {
    text: 'Buscando publicación válida en tu perfil',
    icon: InfoCircle
  },
  USERNAME_NOT_FOUND: {
    text: 'No encontramos un perfil con ese nombre',
    icon: InfoCircle
  },
  VERIFY_HASH: {
    text: 'Publicación no encontrada. Verifica que sea visible y tenga el hashtag e identificador correctos.',
    icon: InfoCircle
  },
  POST_ALREADY_EXIST: {
    text: 'Encontramos una publicación que ya está participando en una misión',
    icon: InfoCircle
  }
} as const;


export const MESSAGE_SAVE_URL_POST: Record<UrlProcessType, MessageType>  = {
  SAVE_URL: {
    text: 'Validando publicación',
    icon: InfoCircle
  },
  URL_INVALID: {
    text: 'Ingresa un enlace válido o intenta con tu nombre de usuario',
    icon: InfoCircle
  },
  URL_NOT_FOUND: {
    text: 'Publicación no encontrada. Verifica que sea visible y tenga el hashtag e identificador correctos.',
    icon: InfoCircle
  },
  URL_ALREADY_EXIST: {
    text: 'Encontramos una publicación que ya está participando en una misión',
    icon: InfoCircle
  }
} as const;